import createReducer from '../../../../../common/utils/createReducer.js';
import { feedBack } from '../actionTypes';

const initialState = {
  feedback_details_widget_data: {},
  feedback_details_data: {},
  isFetchingWidgets: false,
  widgetFetchingError: false,
  isFetchingData: false,
  dataFetchingError: false,
  isAddingNote: false,
  addNoteError: false,
  note_response: null
};

const reducer = {
  [feedBack.SUCCESS_FETCHING_FEEDBACK_DETAILS_WIDGETS]: (state, action) => {
    return {
      ...state,
      isFetchingWidgets: true,
      feedback_details_widget_data: action.payload.feedback_details_widget_data
    };
  },

  [feedBack.FAILURE_FETCHING_FEEDBACK_DETAILS_WIDGETS]: state => {
    return {
      ...state,
      isFetchingWidgets: false,
      widgetFetchingError: true
    };
  },

  [feedBack.SUCCESS_FETCHING_FEEDBACK_DETAILS_DATA]: (state, action) => {
    return {
      ...state,
      isFetchingWidgets: true,
      feedback_details_data: action.payload.feedback_details_data
    };
  },

  [feedBack.FAILURE_FETCHING_FEEDBACK_DETAILS_DATA]: state => {
    return {
      ...state,
      isFetchingWidgets: false,
      widgetFetchingError: true
    };
  },

  // [feedBack.START_ADDING_NOTE]: (state, action) => {
  //   return {
  //     ...state,
  //     isAddingNote: true,
  //   };
  // },

  [feedBack.SUCCESS_ADDING_NOTE]: (state, action) => {
    return {
      ...state,
      isAddingNote: false,
      addNoteError: false,
      note_response: action.payload.note_response
    };
  },

  [feedBack.FAILURE_ADDING_NOTE]: (state, action) => {
    return {
      ...state,
      isAddingNote: false,
      addNoteError: true
    };
  }
};

export default createReducer(initialState, reducer);
